module.exports = __webpack_public_path__ + "img/banner_title.b93f501c.png";